import { organizationsQuery } from '../../graphql/queries/grid/organizations';
import { mapLangToApiFormat } from '../../mappers/organization/organization';
import { LangUtils } from '../../service/Lang/Lang';
import { OrganizationsQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class OrganizationDataProvider extends BaseDataProvider {
    public getOrganizations = (
        login: string,
        organizationIds: string[]
    ): Promise<OrganizationsQuery> => {
        const language = mapLangToApiFormat(LangUtils.getCurrentLang());
        return this.createQuery<OrganizationsQuery>(organizationsQuery, {
            variables: {
                login,
                input: {
                    language,
                    permalinkIds: organizationIds
                }
            }
        }).then(result => result.data);
    };
}
